import React from "react";
import { ApolloLink } from '@apollo/client/link/core';
import Button from '@mui/material/Button';

import i18next from '../../src/i18n/config';
import Snackbar from "../../src/services/snackbar";

let currentVersion = null;

const t = (key) => i18next.t(`apollo-version-tracker.${key}`);

const versionTrackerLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    const context = operation.getContext();
    const newVersion = context.response.headers.get("X-React-App-SHA");

    if (currentVersion && newVersion && currentVersion !== newVersion) {
      Snackbar.info(
        t("newVersion"),
        {
          action: key => <Button onClick={() => window.location.reload()} color="inherit" textSizeSmall sizeSmall>{t("refresh")}</Button>,
          persist: true,
        }
      )
    }

    currentVersion = newVersion;
    return response;
  });
});

export default versionTrackerLink;
